// extracted by mini-css-extract-plugin
export default {"root":"gxcs0j","text":"G79kO3","button":"GoCLTt"};